import { render, staticRenderFns } from "./DashboardFigures.vue?vue&type=template&id=9dba2d3e"
import script from "./DashboardFigures.vue?vue&type=script&lang=ts"
export * from "./DashboardFigures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports